import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
// Using icons from the project's custom FontAwesome kit
import { 
  faClipboardCheck, 
  faExclamationTriangle, 
  faServer, 
  faBook, 
  faShieldCheck,
  faFileAlt
} from  '@awesome.me/kit-269fbef2e2/icons/duotone/solid';

export interface AuditorSidebarItem {
  key: string;
  label: string;
  icon: IconDefinition;
  path: string;
  enabled: boolean;
}

export const DEFAULT_AUDITOR_TABS: AuditorSidebarItem[] = [
  {
    key: 'soa',
    label: 'SOA',
    icon: faClipboardCheck,
    path: '/auditor-view/soa',
    enabled: true
  },
  {
    key: 'policy',
    label: 'Policy',
    icon: faClipboardCheck,
    path: '/auditor-view/policy',
    enabled: true
  },
  {
    key: 'risk-register',
    label: 'Risk Register',
    icon: faExclamationTriangle,
    path: '/auditor-view/risk-register',
    enabled: true
  },
  {
    key: 'asset-register',
    label: 'Asset Register',
    icon: faServer,
    path: '/auditor-view/asset-register',
    enabled: true
  },
  {
    key: 'assurance-library',
    label: 'Assurance Library',
    icon: faShieldCheck,
    path: '/auditor-view/assurance-library',
    enabled: true
  },
  {
    key: 'msg',
    label: 'MSG',
    icon: faBook,
    path: '/auditor-view/msg',
    enabled: true
  },
  {
    key: 'document-library',
    label: 'Document Library',
    icon: faFileAlt,
    path: '/auditor-view/document-library',
    enabled: true
  }
];

export interface AuditorSidebarConfig {
  tabs: AuditorSidebarItem[];
}

// Default configuration with all items enabled
export const DEFAULT_AUDITOR_CONFIG: AuditorSidebarConfig = {
  tabs: DEFAULT_AUDITOR_TABS
};

// Helper function to filter enabled tabs
export function getEnabledTabs(config: AuditorSidebarConfig): AuditorSidebarItem[] {
  return config.tabs.filter(tab => tab.enabled);
}

// Helper function to get tab by key
export function getTabByKey(config: AuditorSidebarConfig, key: string): AuditorSidebarItem | undefined {
  return config.tabs.find(tab => tab.key === key);
}
